import { gql } from '@apollo/client';

export const CREATE_SHL_LEAGUE = gql`
  mutation CreateShlLeague($input: _SHL_LeagueInput!) {
    _SHL_createLeague(input: $input) {
      ok
      error {
        message
      }
      league {
        id
        name
        slug
        status
        format
        legs
        teamsCount
        playersPerTeam
        registrationFee
        flexibleDates
        competitions {
          id
          type
          name
          sport
          format
          legs
          teamsCount
          availability
          settings
          structure {
            name
            phone
            address {
              street
              zip
              city
            }
          }
        }
      }
    }
  }
`;

export const UPDATE_SHL_LEAGUE = gql`
  mutation UpdateShlLeague($id: ID!, $input: _SHL_LeagueUpdateInput!) {
    _SHL_updateLeague(id: $id, input: $input) {
      ok
      error {
        message
      }
      league {
        id
        name
        slug
        status
        format
        legs
        teamsCount
        playersPerTeam
        registrationFee
        flexibleDates
        competitions {
          id
          type
          name
          sport
          format
          legs
          teamsCount
          availability
          settings
          structure {
            name
            phone
            address {
              street
              zip
              city
            }
          }
        }
      }
    }
  }
`;

export const CREATE_SHL_TEAM = gql`
  mutation CreateShlTeam($input: _SHL_TeamInput!) {
    _SHL_createTeam(input: $input) {
      ok
      error {
        message
      }
      team {
        id
        name
        shortName
        logo
        availability
        registrationFee
      }
    }
  }
`;

export const UPDATE_SHL_TEAM = gql`
  mutation UpdateShlTeam($id: ID!, $input: _SHL_TeamUpdateInput!) {
    _SHL_updateTeam(id: $id, input: $input) {
      ok
      error {
        message
      }
      team {
        id
        name
        shortName
        logo
        availability
        registrationFee
      }
    }
  }
`;

export const DELETE_SHL_TEAM = gql`
  mutation DeleteShlTeam($id: ID!) {
    _SHL_deleteTeam(id: $id) {
      ok
      error {
        message
      }
    }
  }
`;

export const GENERATE_SHL_CALENDAR = gql`
  mutation GenerateShlCalendar($leagueId: ID!, $competitionId: ID) {
    _SHL_generateCalendar(leagueId: $leagueId, competitionId: $competitionId) {
      ok
      error {
        message
      }
      matches {
        id
        competitionId
        groupId
        stage
        stageRound
        matchdayNumber
        leg
        homeTeamId
        awayTeamId
        scheduledAt
        structure {
          name
          phone
          address {
            street
            zip
            city
          }
        }
        status
      }
    }
  }
`;

export const ADD_SHL_PLAYER_TO_TEAM = gql`
  mutation AddShlPlayerToTeam($input: _SHL_PlayerInput!) {
    _SHL_addPlayerToTeam(input: $input) {
      ok
      error {
        message
      }
      player {
        id
        displayName
        position
      }
    }
  }
`;

export const REMOVE_SHL_PLAYER_FROM_TEAM = gql`
  mutation RemoveShlPlayerFromTeam($teamId: ID!, $playerId: ID!) {
    _SHL_removePlayerFromTeam(teamId: $teamId, playerId: $playerId) {
      ok
      error {
        message
      }
    }
  }
`;

export const UPDATE_SHL_MATCH = gql`
  mutation UpdateShlMatch($id: ID!, $input: _SHL_MatchUpdateInput!) {
    _SHL_updateMatch(id: $id, input: $input) {
      ok
      error {
        message
      }
      match {
        id
        groupId
        stage
        stageRound
        scheduledAt
        matchdayNumber
        competitionId
        status
        result {
          home
          away
          outcome
        }
        notes
      }
    }
  }
`;
